<template>
  <div class="box">

    <div class="handle-box-search">

      <el-row type="flex" justify="center" style="margin-bottom: 20px;">

        <span style="display: inline-block;width: 100px;text-align: right;margin-right: 5px;">模式:</span>
        <el-select v-model="submit_data.order_time" placeholder="请选择模式" style="width: 200px; margin-right: 20px;"
                   clearable>
          <el-option label="下单时间" value="order_time_stamp"></el-option>
          <el-option label="服务完成时间" value="end_time_stamp"></el-option>
          <el-option label="订单支付时间(结束)" value="pay_time_stamp"></el-option>
        </el-select>


      </el-row>


      <el-row type="flex" justify="center" style="margin-bottom: 20px;">

        <span style="display: inline-block;width: 100px;text-align: right;margin-right: 5px;">订单类型:</span>
        <el-select v-model="submit_data.type" placeholder="请选择模式" style="width: 200px; margin-right: 20px;"
                   clearable>
          <el-option label="当前订单" value="0"></el-option>
          <el-option label="历史订单" value="1"></el-option>
          <el-option label="全部当前订单" value="2"></el-option>
          <el-option label="全部历史订单" value="3"></el-option>
          <el-option label="销单订单" value="4"></el-option>
          <el-option label="历史销单订单" value="5"></el-option>
        </el-select>


      </el-row>


      <el-row type="flex" justify="center" style="margin-bottom: 20px;">

        <span style="display: inline-block;width: 80px;text-align: right; margin-right: 5px;">时间:</span>
        <el-date-picker v-model="search_time" type="datetimerange" range-separator="-" start-placeholder="开始日期"
                        end-placeholder="结束日期" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" @change="timeChange"
                        style="width: 200px;">
        </el-date-picker>



      </el-row>


      <el-row type="flex" justify="center" style="margin-bottom: 20px;">

        <span style="display: inline-block;width: 80px;text-align: right; margin-right: 5px;">密码:</span>
        <el-input v-model="submit_data.export_password" style="width: 200px;" show-password></el-input>



      </el-row>


      <el-row type="flex" justify="center" style="margin-bottom: 20px;">

        <span style="display: inline-block;width: 80px;text-align: right; margin-right: 5px;">司机手机号:</span>
        <el-input v-model="submit_data.driver_phone" style="width: 200px;" maxlength="11"></el-input>



      </el-row>

      <el-row type="flex" justify="center" style="margin-bottom: 20px;">
        <span style="display: inline-block;width: 100px;text-align: right; margin-right: 5px;">订单渠道:</span>
        <el-select
                v-model="submit_data.order_source"
                placeholder="请选择渠道"
                clearable
                style="width: 200px; margin-right: 20px;"
        >
          <el-option
                  :label="item.name"
                  :value="item.order_source"
                  v-for="item in partnerList"
          >
          </el-option>



        </el-select>



      </el-row>


      <div style="width: 500px; margin: 10px auto;" v-if="progress_show">

        <el-progress :percentage="progress_data"></el-progress>
        <i class="el-icon-loading"></i>
        正在导出...

      </div>

      <el-row type="flex" justify="center" v-else>

        <el-button type="primary" @click="toExport">导出订单信息</el-button>


      </el-row>



    </div>




  </div>

</template>

<script>
  import axios from 'axios';
  import { config } from '@/utils/config.js';
  import bus from '../../common/bus'; //配置
  var _this;
  export default {

    data() {
      return {
        search_time: '',

        submit_data: {
          page: 1,
          fixed_array: '',
          order_time:'',
          type:'',
          // city_code: localStorage.,
          export_password: '',
          driver_phone:'',
          order_source:''
        },

        partnerList:[],

        excelData: [],

        excelHead: [],

        progress_show: false,
        progress_data: 0

      };
    },
    created() {
      _this = this;
      console.log(this.$route.path);

      axios.defaults.baseURL = config.axios_normalURL; //请求normal url
      _this
              .$post('/order/getPartnerList', {}, {},'normal')
              .then((res) => {


                _this.partnerList = res.data
                axios.defaults.baseURL = config.axios_baseURL; //请求normal url

              })
              .catch((err) => {
              });
      axios.defaults.baseURL = config.axios_baseURL; //请求normal url


      bus.$on('btnStatus',(msg)=>{
        _this.progress_show = msg;
      });

    },

    methods: {
      timeChange(val) {
      if(val!=null){
        _this.submit_data.fixed_array = JSON.stringify(['between'].concat(val));

      }else{
        _this.submit_data.fixed_array = ''
      }

      },

      toExport() {

        _this.progress_show = true;
        _this.getExcelData();

      },

      getExcelData() {

        _this.$post(
                "/order/getOrderVisitCSV",
                _this.submit_data
        ).then(res => {



          if (this.$route.path == '/orderExport') {


            // 导出excel的空数组中添加数据
            for (let i = 0; i < res.data.list.length; i++) {
              console.log(res.data.list[i].order_code);
              _this.excelData.push({
                'driver_name': res.data.list[i].driver_real_name,
                'driver_phone': res.data.list[i].driver_phone,
                'consumer_phone': res.data.list[i].consumer_phone,
                'balance': res.data.list[i].balance,
                'is_vip': res.data.list[i].is_vip,
                'is_new_visit':res.data.list[i].is_new_visit.alias,
                'start_name': res.data.list[i].start_name,
                'end_name': res.data.list[i].end_name,
                'platform': res.data.list[i].platform.alias,
                'amount': res.data.list[i].amount,
                'finish_amount': res.data.list[i].finish_amount,
                'order_time': res.data.list[i].order_time.YmdHis,
                'end_time': res.data.list[i].end_time.YmdHis,
                'admin_name': res.data.list[i].admin_name,
                'trade_no':res.data.list[i].trade_no,
                'pay_no':res.data.list[i].pay_no,
                'is_group_pay':res.data.list[i].is_group_pay,
                'pay_mode':res.data.list[i].pay_mode.alias,
                'pay_channel':res.data.list[i].pay_channel.alias,
                'coupon_amount':res.data.list[i].coupon_amount,
                'coupon_bear_price':res.data.list[i].coupon_bear_price,
                'coupon_code':res.data.list[i].coupon_code,
                'order_type':res.data.list[i].order_type,
                'driver_amount':res.data.list[i].driver_amount,
                'voucher_amount':res.data.list[i].voucher_amount,
                'pay_time':res.data.list[i].pay_time.YmdHis,
                'bank_cards':res.data.list[i].bank_cards,
                'on_way_distance':res.data.list[i].on_way_distance,
                'billno':res.data.list[i].billno,
                'insurance':res.data.list[i].insurance,
                'order_mode_name':res.data.list[i].order_mode.name,
                'use_time':res.data.list[i].use_time,
                'order_code':res.data.list[i].order_code,
                'equity_amount':res.data.list[i].equity_amount,
                'equity_kilo':res.data.list[i].equity_kilo,
                'price_amount':res.data.list[i].price_amount,
                'agent_money':res.data.list[i].agent_money,
                'company_money':res.data.list[i].company_money,
                'order_source':res.data.list[i].order_source,
                'group_name':res.data.list[i].group_name
              });


            }



            if (res.data.page * res.data.limit < res.data.count) {

              _this.submit_data.page = res.data.page + 1;

              _this.progress_data = Math.floor((res.data.page * res.data.limit / res.data.count) * 100);

              _this.getExcelData();

            } else {

              // console.log(_this.excelData);

              // 将数据导出execl
              _this.exportData();

              _this.submit_data.page = 1;

              // 清空数据
              _this.excelData = [];

              _this.progress_show = false;
              _this.progress_data = 0;


            }

          } else {

            _this.progress_show = false;
            _this.progress_data = 0;

          }



        }).catch((err) => {

        })

      },


      // 导出excel方法
      exportData() {
        const {
          export_json_to_excel
        } = require('@/vendor/Export2Excel');
        const tHeader = ['下单时间','完成时间','支付时间', '司机姓名', '司机电话', '乘客电话', '账户余额', '用户类型', '新老用户','起点',
          '终点', '平台来源', '订单实际金额','客户实际支付金额', '订单来源','平台交易号','系统交易号','是否为集团',
          '集团名称','支付方式','支付通道','优惠卷编码','优惠卷金额','优惠卷司机承担金额','订单支付状态','司机实际收到金额',
          '优惠卡减免金额','银行卡','总公里数','订单编号','保险金','订单模式','订单时长','订单唯一编码值','权益金额','权益公里数','现金券使用金额',
        '加盟商清分金额','总公司清分金额','订单渠道'];


        const filterVal = ['order_time','end_time','pay_time','driver_name', 'driver_phone', 'consumer_phone',
          'balance','is_vip','is_new_visit', 'start_name', 'end_name',
          'platform', 'amount','finish_amount','admin_name','trade_no','pay_no','is_group_pay',
          'group_name','pay_mode','pay_channel','coupon_code','coupon_amount','coupon_bear_price',
          'order_type','driver_amount','voucher_amount','bank_cards','on_way_distance','billno','insurance','order_mode_name','use_time','order_code','equity_amount','equity_kilo','price_amount',
          'agent_money','company_money','order_source'
        ];
        const list = this.excelData;
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, 'fileName');
      },

      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
      },




    }
  };
</script>

<style scoped>

</style>
